import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';
import {
  MCP_GUIDE_HREF,
  MCP_URL,
  MCPDescription,
  MCPGuideLink,
  MCPUrlField,
} from '../../Analytics/MCPConnectionSection';

/**
 * Settings -> MCP. The same connection details as a space's Analytics page, reachable from
 * organization settings so MCP is not only discoverable from inside a space. (#3076)
 *
 * Open to every member, not only admins: each person connects their own AI client.
 */
export default function McpSettings() {
  const { copy } = useCopyToClipboard();

  return (
    <div className="mx-auto w-full max-w-5xl px-12">
      <div className="mb-6 mt-8 text-xl font-semibold leading-7 text-brand-grey-dark">MCP</div>

      <section className="max-w-[768px] rounded-lg border border-solid border-neutral-300 p-6">
        <h2 className="m-0 text-base font-semibold leading-6 text-brand-grey-dark">Connect to Taskonio MCP</h2>
        <MCPDescription className="m-0 mt-6" />
        <div className="mt-8 max-w-[521px]">
          <MCPUrlField mcpUrl={MCP_URL} onCopyUrl={() => void copy(MCP_URL, 'MCP URL copied')} />
        </div>
        <div className="mt-6">
          <MCPGuideLink guideHref={MCP_GUIDE_HREF} />
        </div>
      </section>
    </div>
  );
}
